import React from "react";
import clsx from "clsx";
import MenuItem from "./MenuItem";
import useBuildingTabOptions from "hooks/useBuildingTabOptions";

const BuildingMenu = () => {
  const { options, rightOptions } = useBuildingTabOptions();

  return (
    <div className="sticky top-[64px] flex border-b h-[56px] bg-white shadow-sm px-6 z-10 max-w-full">
      <div className="flex justify-between w-full items-center relative">
        <div
          className={clsx(
            "z-10 print:hidden flex items-center",
            "border-gray-300 text-gray-500 hover:text-gray-700 overflow-x-auto relative pr-40"
          )}
        >
          {options.map((rec, index) => (
            <MenuItem key={index} item={rec} />
          ))}
        </div>
        <div className="absolute right-0 flex top-0 z-20 h-full">
          <div className="w-7 bg-gradient-to-r from-transparent to-white"></div>
          <div className="flex items-center bg-white">
            {rightOptions.map((rec, index) => (
              <MenuItem key={index} item={rec} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildingMenu;
